// src/themes.js

export const themes = {
  blue: {
    primaryColor: "#2196F3",
    accentColor: "#1565C0",
    backgroundColor: "#E3F2FD",
    textColor: "#0D47A1", // Dark blue for primary text
    buttonTextColor: "#FFFFFF", // White text for buttons
    secondaryColor: "#64B5F6",
  },
  green: {
    primaryColor: "#4CAF50",
    accentColor: "#388E3C",
    backgroundColor: "#E8F5E9",
    textColor: "#1B5E20", // Dark green for primary text
    buttonTextColor: "#FFFFFF", // White text for buttons
    secondaryColor: "#81C784",
  },
  orange: {
    primaryColor: "#FF9800",
    accentColor: "#EF6C00",
    backgroundColor: "#FFF3E0",
    textColor: "#E65100", // Dark orange for primary text
    buttonTextColor: "#FFFFFF", // White text for buttons
    secondaryColor: "#FFB74D",
  },
  purple: {
    primaryColor: "#9C27B0",
    accentColor: "#6A1B9A",
    backgroundColor: "#F3E5F5",
    textColor: "#4A148C", // Dark purple for primary text
    buttonTextColor: "#FFFFFF", // White text for buttons
    secondaryColor: "#BA68C8",
  },
  red: {
    primaryColor: "#F44336",
    accentColor: "#D32F2F",
    backgroundColor: "#FFEBEE",
    textColor: "#B71C1C", // Dark red for primary text
    buttonTextColor: "#FFFFFF", // White text for buttons
    secondaryColor: "#EF9A9A",
  },
  teal: {
    primaryColor: "#009688",
    accentColor: "#00796B",
    backgroundColor: "#E0F2F1",
    textColor: "#004D40", // Dark teal for primary text
    buttonTextColor: "#FFFFFF", // White text for buttons
    secondaryColor: "#4DB6AC",
  },
  gray: {
    primaryColor: "#607D8B",
    accentColor: "#455A64",
    backgroundColor: "#ECEFF1",
    textColor: "#263238", // Dark gray for primary text
    buttonTextColor: "#FFFFFF", // White text for buttons
    secondaryColor: "#B0BEC5",
  },
  yellow: {
    primaryColor: "#FFEB3B",
    accentColor: "#FBC02D",
    backgroundColor: "#FFF9C4",
    textColor: "#F57F17", // Dark yellow for primary text
    buttonTextColor: "#000000", // Black text for buttons
    secondaryColor: "#FFF176",
  },
  pink: {
    primaryColor: "#E91E63",
    accentColor: "#C2185B",
    backgroundColor: "#FCE4EC",
    textColor: "#880E4F", // Dark pink for primary text
    buttonTextColor: "#FFFFFF", // White text for buttons
    secondaryColor: "#F8BBD0",
  },
  brown: {
    primaryColor: "#795548",
    accentColor: "#5D4037",
    backgroundColor: "#D7CCC8",
    textColor: "#3E2723", // Dark brown for primary text
    buttonTextColor: "#FFFFFF", // White text for buttons
    secondaryColor: "#A1887F",
  },
  cyan: {
    primaryColor: "#00BCD4",
    accentColor: "#00838F",
    backgroundColor: "#E0F7FA",
    textColor: "#006064", // Dark cyan for primary text
    buttonTextColor: "#FFFFFF", // White text for buttons
    secondaryColor: "#4DD0E1",
  },
  black: {
    primaryColor: "#212121",
    accentColor: "#424242",
    backgroundColor: "#FAFAFA",
    textColor: "#000000", // Black for primary text
    buttonTextColor: "#FFFFFF", // White text for buttons
    secondaryColor: "#BDBDBD",
  },
};
